import { render } from "./CategoryOverview.vue?vue&type=template&id=f10f9032&scoped=true"
import script from "./CategoryOverview.vue?vue&type=script&lang=js"
export * from "./CategoryOverview.vue?vue&type=script&lang=js"

import "./CategoryOverview.vue?vue&type=style&index=0&id=f10f9032&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f10f9032"]])

export default __exports__